export enum EScheduleAction {
  SYNC_UTM = 'SYNC_UTM',
}
